// /ae/blogs - UAE blog home (components/market/MarketBlogsPage). The cards
// come from lib/market-blogs.js; this is the page's own copy. "AC" only, never
// "aircon"; nothing lifted from /sg/blogs.
const content = {
    title: 'AC & Fitness Guides for Dubai and Abu Dhabi | StringsSG UAE',
    description:
        'Local guides for UAE homes: who pays for AC maintenance, district cooling vs split AC, AC ton sizing, pre-summer checks, Ramadan workouts, gym costs and becoming a personal trainer.',
    about:
        'Welcome to the StringsSG UAE blog. Our guides are written for homes in Dubai and Abu Dhabi: keeping your AC running through the summer, what your tenancy says about AC maintenance, how district cooling works, and training around Ramadan, the heat and the Dubai Fitness Challenge.',
    h1: 'Latest Guides for UAE Homes and Fitness',
    // Category pages, by vertical: /ae/blogs/ac-guides, /ae/blogs/fitness-guides.
    categories: {
        aircon: {
            title: 'AC Guides for Dubai and Abu Dhabi Homes | StringsSG UAE',
            description: 'AC guides for UAE homes: landlord vs tenant maintenance, district cooling vs split AC, duct vs coil cleaning, AC ton sizing and a pre-summer checklist.',
            h1: 'AC Guides & Tips for UAE Homes',
        },
        pt: {
            title: 'Fitness Guides for Dubai | Training Plans & Tips | StringsSG UAE',
            description: 'Fitness guides for the UAE: a Dubai Fitness Challenge plan, training during Ramadan, what gyms cost in Dubai and how to become a personal trainer.',
            h1: 'Fitness Guides & Training Tips for the UAE',
        },
    },
}

export default content
